import { useEffect, useState } from "react"
import { RequestConfigs } from "../../api"
import { useFormHandling } from "../../hooks/formUtils"
import { Col, DotListItem, ListItem, Row, StatusBox, Text, Toggle, VImage } from "../../style/base.style"
import { useDictionary } from "../../contexts/dictionary"
import { useContactType } from "../../contexts/ContactContext"
import { PopupLayout } from "../common/popup"
import { ActionButton, ButtonStyle } from "../buttons/ActionButton"
import { Colors } from "../../style/colors"
import { doctorIcon } from "../../constants/images"

interface AppointmentsProps {
  minimize?:boolean
}

export const Appointments = ({minimize}:AppointmentsProps) => {

    
  const { handleClick, serverRes } = useFormHandling({ requestType: RequestConfigs.getAppointment })
  const {translate} = useDictionary()

  const [appointments, setAppointments] = useState<Appointment[] | null>(null)

    const [openPopup,setOpenPopup] = useState<number>(-1)

    const closePopup = () => {
      setOpenPopup(-1)
    }

    const openPopupAction = (index:number) => {
      console.log('openPopupAction',index)
      setOpenPopup(index)
    }
    const {contact} = useContactType()

    useEffect(() => {
        handleClick()
    }, [contact])

    useEffect(() => {
        handleClick()
    }, [])

    useEffect(() => {

        if (serverRes?.appointments) {
            setAppointments(serverRes.appointments)
        }
  }, [serverRes])

    return (
        <>
        
            <table className="table dashboard-table" style={{ borderSpacing: '0 5px',  borderCollapse: 'separate' }}>
                <tbody >
                    { appointments &&
                        appointments?.map((appointment, index) => (
                          
                          
                            <Row $margin="10px 0" $width="100%" $justifyContent="space-between" $alignItems="center" key={index} $padding="10px" $gap={10} style={{borderRadius: '10px',border: `1px solid ${Colors.fieldBorder}`}}>
                              <CancelAppointmentPopup isOpen={openPopup===index} onClose={()=>closePopup()} appointment={appointment}/>
                          
                         
                              <Row className="right-sec" $width={minimize?"100%":"75%"} $justifyContent="flex-start" $alignItems="center" $gap={10} $backgroundColor="blue">
                              <Col $backgroundColor={Colors.primary} $borderRadius={15} $padding="10px">
                                <VImage src={doctorIcon} $width={"30px"} $height={"30px"} />
                              </Col>
                              
                               <Col $alignItems="flex-start" $width="80%">
                               
                                  <h4>{appointment.docotorName || translate("waiting_for_doc_assignment")}</h4>
                                  <Row $justifyContent="flex-start" $alignItems="center" $gap={10}>
                                    <Text $margin="0" $fontSize="13px" className="fa-solid fa-clock">{new Date(appointment.scheduledTime).toLocaleString()}</Text>
                                    <StatusBox $status={appointment.status} >{translate(appointment.status)}</StatusBox>

                                  </Row>
                                  
                                  <Row $width="100%" $justifyContent="flex-start" $alignItems="center" $gap={10}>
                                
                                  </Row>
                                  
                                  </Col>
                              </Row>
                            
                            {
                              !minimize && 
                              <Row $width="15%" $justifyContent="flex-end" $alignItems="center" $gap={10}>
   
                              { appointment.status === "pending" &&
                                <ActionButton style={ButtonStyle.red} width="100px" label={translate("cancel")} onClick={()=>openPopupAction(index)} />
                              }
                              
                             
                            

                              </Row>
                       
                            }
                          
                            
                          </Row>
                        ))
                    }
                    {
                        !appointments?.length && 
                        <>
                        <Col $width="100%" $alignItems="center" $justifyContent="center" $padding="50px">
                            <h3>{translate('no_appointments')}</h3>
                        </Col>
                        </>
                    }

                </tbody>
            </table>
        </>
    )
}




interface CancelAppointmentPopupProps {
  isOpen:boolean
  onClose:()=>void
  appointment:Appointment
}

const CancelAppointmentPopup = ({isOpen,onClose,appointment}:CancelAppointmentPopupProps) => {
  const {handleClick,serverRes} = useFormHandling({requestType:RequestConfigs.cancelAppointment,data:{id:appointment.id}})
  const {contact} = useContactType()
  const {translate} = useDictionary()


 useEffect(() => {
    if(serverRes){
      if(serverRes.succeeded){
        onClose()
      }
    }
  
 }, [serverRes]);

  return (
    <PopupLayout isOpen={isOpen} onClose={onClose}>
      <Text>{translate('appointment_cancel_verify')}{" "}{contact?.Full_Name}</Text>
      <Row $width='100%' $justifyContent='center' $gap={10}>
        <ActionButton style={ButtonStyle.light} width='100px' label={translate('cancel')} onClick={onClose} />
        <ActionButton style={ButtonStyle.dark} width='100px' label={translate('confirm')} onClick={handleClick} />
      </Row>
    </PopupLayout>
  )
}


